import $ from 'jquery';
import Promise from 'promise'

/*
 提供默认搜索数据，可覆盖 返回一个promise, setting为一个对象
 */
function fetchData(setting) {
    // 合并参数
    let param = $.extend({
        // default setting
        url: '',
        sendData: {},
        dataType: 'json',
        type: 'GET'
    }, setting);

    return new Promise(function (resolve, reject) {
        $.ajax({
            url: param.url,
            data: param.sendData,
            type: param.type,
            dataType: param.dataType,
            xhrFields: {
                withCredentials: true // POST跨域后支持cookie操作
            }
        }).done(res => {
            resolve(res);
        }).fail(e => {
            // console.log('ajax 失败了',e);
            reject(e);

        });
    });
}

function postData(setting) {
    let param = $.extend({
        url: '',
        sendData: {},
        dataType: 'json',
        type: 'POST'
    }, setting);


    return new Promise(function (resolve, reject) {
        $.ajax({
            url: param.url,
            data: param.sendData,
            type: param.type,
            dataType: param.type,
            xhrFields: {
                withCredentials: true // POST跨域后支持cookie操作
            }
        }).done(res => {
            resolve(res);
        }).fail(e => {
            // console.log('post ajax 失败了',e);
            reject(e);

        });
    });
}

function sendDataFormat(params = [], config = {}){
    let obj = {};
    if (params.length > 0){ 
        params.forEach((ele) => {
            obj[ele] = config[ele];
        });
    }
    return obj;
}

function getHost(option) {
    let result = '//www.dianping.com';
    if (location.href.indexOf('localhost') != -1) {
        if (option && option.httpsOnly) {
            result = 'https://w.51ping.com';
        } else { 
            result = '//w.51ping.com';
        }
    } else if (location.href.indexOf('51ping') != -1) {
        if (option && option.httpsOnly) {
            result = 'https://w.51ping.com';
        } else { 
            result = '//w.51ping.com';
        }
    } else if (location.href.indexOf('ppe') != -1) {
        result = '//ppe.m.dianping.com';
    } else if (location.href.indexOf('dianping') != -1) {
        if (option && option.httpsOnly) {
            result = 'https://www.dianping.com';
        } else { 
            result = '//www.dianping.com';
        }
    }
    return result;
}

/**
 * 正则表达式过滤xss代码
 * @param {string} str 
 */
const transXSS = function (str) {
    
        return str ? str.replace(/[<>"]/g, function (target) {
    
            return {
                '<': '&lt;',
                '>': '&gt;',
                '"': '&quot;'
            }[target];
    
        }) : str;
    
    }

export {
    fetchData,
    postData,
    getHost,
    transXSS,
    sendDataFormat
}


// WEBPACK FOOTER //
// ./modules/common/js/util.js